function getUnifySelectInventoryActivityRequestCheckParamsSomeParams({ orderParam }) {
  const checkBrand = orderParam && orderParam.checkBrand;
  const checkCategory = orderParam && orderParam.checkCategory;
  const checkProductChannel = orderParam && orderParam.checkProductChannel;
  const { orderCategory, orderType, productType, activityType } = orderParam;
  const leave = +orderParam.leave;
  const repeatOrder = orderParam.repeatOrder === "" || orderParam.repeatOrder == null ? null : +orderParam.repeatOrder;
  return {
    checkBrand,
    checkCategory,
    checkProductChannel,
    orderCategory,
    orderType,
    productType,
    activityType,
    leave,
    repeatOrder
  };
}
export { getUnifySelectInventoryActivityRequestCheckParamsSomeParams };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getUnifySelectInventoryActivityRequestCheckParamsSomeParams.js